import axiosClient from '../axiosClient';

const branchAPI = {
    async getBranchList(params) {
        const url = `/branch`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
};

export default branchAPI;
